module.exports = __webpack_public_path__ + "static/media/star-exclamation.e583b4ef.svg";